import axios from 'axios';

// 页面说明文案统一来自 conghua_api /api/ui/tooltips（MySQL chong_ui_tooltip_config），
// 与 CREITs 前端同一套配置；配置服务不可用时不影响业务页面，入口不显示即可。
let configPromise = null;

export function loadTooltipConfigs({ force = false } = {}) {
  if (force || !configPromise) {
    configPromise = axios
      .get('/api/ui/tooltips')
      .then((response) => {
        const payload = (response && response.data) || {};
        return (payload.success && payload.data && payload.data.byKey) || {};
      })
      .catch(() => {
        configPromise = null;
        return {};
      });
  }
  return configPromise;
}

export function resolveTooltipConfig(configKey) {
  return loadTooltipConfigs().then((configs) => configs[configKey] || null);
}
